import { CommonTools } from '../../../shared/helpers/common-tools';
import { Component, OnInit } from "@angular/core";
import { MDBModalService } from "angular-bootstrap-md";
import { EntityType } from "../../../models/enums/entityType";
import { StructureProperties } from "../../../models/structure-properties.model";
import { ModelService } from "../../../services/model.service";
import { THERMAL_REGIME_UNDER_FLOOR_OPTIONS_REDUCED } from '../../../models/enums/Space-properties-enums.model';
import { FloorDefinition } from '../../../models/floor-definition.model';

@Component({
    selector: "app-floor-definition-modal",
    templateUrl: "./floor-definition-modal.component.html",
    styleUrls: ["./floor-definition-modal.component.scss"],
})
export class FloorDefinitionModalComponent implements OnInit {
    public externalId: string;

    public floorDefinition: FloorDefinition = null;
    public structureProperties: StructureProperties[] = [];
    THERMAL_REGIME_OPTIONS = THERMAL_REGIME_UNDER_FLOOR_OPTIONS_REDUCED;

    private isNewWindow: boolean;

    constructor(private model: ModelService, private mdbModalService: MDBModalService) {
        this.model.SelectedProject$.subscribe((project) => {
            if (project) this.structureProperties = project.structureProperties;
        });
    }

    ngOnInit() {
        if (this.externalId) {
            this.floorDefinition = this.model.getEntityByExternalId<FloorDefinition>(EntityType.FloorDefinition, this.externalId);
        }
        if (this.floorDefinition) {
            this.isNewWindow = false;
        } else {
            this.floorDefinition = new FloorDefinition();
            this.floorDefinition.name = this.model.generateName(this.floorDefinition);
            this.floorDefinition.externalId = this.externalId ? this.externalId : CommonTools.GetUUID();
            this.isNewWindow = true;
        }
    }

    onSave() {
        if (this.isNewWindow) {
            this.model.AddEntity(this.floorDefinition);
        } else {
            this.model.UpdateEntity(this.floorDefinition);
        }

        this.mdbModalService.hide(this.mdbModalService["loaders"].length);
    }

    onCancel() {
        this.mdbModalService.hide(this.mdbModalService["loaders"].length);
    }
}
